// import { COLOR_ATTRIBUTE, MATERIAL_ATTRIBUTE, STONE_ATTRIBUTE } from
// 'Component/ProductConfigurableAttributes/ProductConfigurableAttributes.config';
import ProductListQuery from 'Query/ProductList.query';
import {
    ProductListDispatcher as SourceProductListDispatcher
} from 'SourceStore/ProductList/ProductList.dispatcher';
import { updateNoMatch } from 'Store/NoMatch/NoMatch.action';
import {
    appendPage,
    cleanProductList,
    removeProductListItems,
    updateLoadStatus,
    updatePageLoadingStatus,
    updateProductListItems
} from 'Store/ProductList/ProductList.action';
import { makeCancelable } from 'Util/Promise';
import { Field, prepareQuery } from 'Util/Query';
import { hash } from 'Util/Request/Hash';
import { executeGet, listenForBroadCast } from 'Util/Request/Request';

export const ONE_MONTH_IN_SECONDS = 2592000;
export const TWELEVE_HOURS_IN_SECONDS = 43200;
export const FIVE_MINUTES_IN_SECONDS = 300;
/** @namespace Bodypwa/Store/ProductList/Dispatcher */
export class ProductListDispatcher extends SourceProductListDispatcher {
    onSuccess(data, dispatch, options) {
        const { args, isNext, args: { filter: { categoryIds }, search } } = options;
        const { currentPage } = args;
        const {
            products: {
                items,
                total_count,
                page_info: { total_pages } = {}
            } = {}
        } = data;

        const id = categoryIds || search;
        if (isNext) {
            return dispatch(
                appendPage(
                    items,
                    currentPage,
                    id
                )
            );
        }

        return dispatch(
            updateProductListItems(
                items,
                currentPage,
                total_count,
                total_pages,
                args,
                id
            )
        );
    }

    cleanProductList(dispatch) {
        dispatch(cleanProductList(dispatch));
    }

    removeProductListItems(currentPage, dispatch) {
        dispatch(removeProductListItems(currentPage, dispatch));
    }

    appendPage(items, currentPage, dispatch) {
        dispatch(
            appendPage(
                items,
                currentPage
            )
        );
    }

    // TODO make part of base logic
    /**
     * Is responsible for request routing and manages `onError`, `onSuccess`, `onUpdate` functions triggers.
     * @param  {Function} dispatch Store changing function from Redux (dispatches actions)
     * @param  {any} options Any options received from Container
     * @return {void}@memberof QueryDispatcher
     */
    handleData(dispatch, options) {
        const { cacheTTL } = this;
        const { args } = options;

        const name = `ProductList${ hash(JSON.stringify(args)) }`;
        const rawQueries = this.prepareRequest(options, dispatch);

        if (!rawQueries) {
            return;
        }

        const queries = rawQueries instanceof Field ? [rawQueries] : rawQueries;

        if (this.promise) {
            this.promise.cancel();
        }

        this.promise = makeCancelable(
            new Promise((resolve, reject) => {
                executeGet(prepareQuery(queries), name, cacheTTL)
                    .then(
                    /** @namespace Bodypwa/Store/ProductList/Dispatcher/ProductListDispatcher/handleData/makeCancelable/executeGet/then/resolve */
                        (data) => resolve(data),
                        /** @namespace Bodypwa/Store/ProductList/Dispatcher/ProductListDispatcher/handleData/makeCancelable/executeGet/then/reject/catch */
                        (error) => reject(error)
                    );
            })
        );

        this.promise.promise.then(
        /** @namespace Bodypwa/Store/ProductList/Dispatcher/ProductListDispatcher/handleData/then */
            (data) => this.onSuccess(data, dispatch, options),
            /** @namespace Bodypwa/Store/ProductList/Dispatcher/ProductListDispatcher/handleData/then/catch */
            (error) => this.onError(error, dispatch, options),
        );

        listenForBroadCast(name).then(
        /** @namespace Bodypwa/Store/ProductList/Dispatcher/ProductListDispatcher/handleData/listenForBroadCast/then */
            (data) => this.onUpdate(data, dispatch, options),
        );
    }

    prepareRequest(options, dispatch) {
        const { isNext } = options;

        if (!isNext) {
            dispatch(updateLoadStatus(true));
        } else {
            dispatch(updatePageLoadingStatus());
        }

        return ProductListQuery.getQuery(options);
    }

    onError(error, dispatch) {
        dispatch(updateNoMatch(true));
    }
}

export default new ProductListDispatcher();
